<template>
    <div @click="$emit('close')" class="transition-all test flex flex-col fixed top-0 left-0 w-screen h-screen  items-center justify-center  z-40 bg-[#00000063] backdrop-blur-[2px]  text-lg">
        <div :class="{'border-[#12760A]': success ,'border-[#AB0000]': !success ,}" class="w-[700px] rounded-lg border-[2px] hover:transition-all	 bg-white">
            <div :class="{'bg-[#12760A]': success ,'bg-[#AB0000]': !success ,}" class=" flex flex-col items-center py-10 gap-3 shadow-2xl ">
                <div >
                    <SuccessLogo v-if="success" />
                    <ErrorLogo  v-if="!success" />
                </div>
                
                <p class="font-semibold text-white text-xl tracking-wide">{{ header }}</p>
                <p class="text-white text-sm">{{ header1 }}</p>
                <input v-if="remarks" type="text" placeholder="Type your reason for disapproval here..." class="w-[90%] text-sm p-3 rounded-lg px-6 outline-none text-[#4b4b4b]" v-model="remarksval">
            </div>
            <div class="h-[80px] flex justify-center items-center gap-5 ">
                <div v-if="remarks" class="flex gap-10">
                    <button :class="{'bg-[#12760A]': success ,'bg-[#AB0000]': !success ,}" class="px-9 py-3 text-sm text-white rounded-full shadow-2xl w-[150px]" @click="$emit('remarks', remarksval)" >Disapprove</button>
                    <button  class="px-9 py-3 text-sm text-white rounded-full shadow-2xl w-[150px] bg-[#9da09d]" @click="$emit('close')">Cancel</button>
                </div>
                <div v-else>
                    <button :class="{'bg-[#12760A]': success ,'bg-[#AB0000]': !success ,}" class="px-9 py-3 text-sm text-white rounded-full shadow-2xl w-[150px]" @click="$emit('close')">Close</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from "vue"
import SuccessLogo from "@/components/controls/Prompt/PromptSvg/SuccessSvg.vue"
import ErrorLogo from "@/components/controls/Prompt/PromptSvg/ErrorSvg.vue"


export default defineComponent({
    components:{
        SuccessLogo,
        ErrorLogo,
    },
    data(){
        return{
            remarksval:       '',
        }
    },
    props:{
        type:{
            type: String
        },
        remarks:{
            type: Boolean,
            default: false
        },
        success:{
            type: Boolean,
            default: true,
        },
        header:{
            type: String,
            default : 'header'
        },
        header1:{
            type: String,
            default : 'header1'
        },
    
    },
    mounted(){
      this.DataType = this.type

    },
    methods:{
       
           
    }


})




</script>